import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import MainLayout from "./components/MainLayout";
import Register from "./pages/Signup";
import CategoryManager from "./pages/CategoryManager";
import SubCategoryManager from "./pages/SubCategoryManager";
import AdminUsersPage from "./pages/AllUsers";
import BannerUpload from "./pages/UploadBanners";
import NewsAlertsForm from "./pages/NewsAlertsForm";
import ProductsPage from "./pages/ProductsPage";
import ProductDeals from "./pages/ProductDeals";
import ProductColorsPage from "./pages/ProductColorsPage";
import AdminSubMainCategories from "./pages/AdminSubMainCategories";
import AdminBusinessTools from "./pages/AdminBusinessTools";
import TemplateTypeManager from "./pages/AddTemplateType";
import TemplateCRUD from "./pages/AdminTemplates";
import AddSize from "./pages/AddSize";
import AddCars from "./pages/AddCars";
import AddTypes from "./pages/AddTypes";
import StaticDesignForm from "./pages/AddTemplateSideData";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/signup" element={<Register />} />
                <Route path="/admin" element={<MainLayout />}>
                    <Route index element={<Dashboard />} />
                    <Route path="Add-category-manager" element={<CategoryManager />} />
                    <Route path="Add-subcategory-manager" element={<SubCategoryManager />} />
                    <Route path="Add-Cars" element={<AddCars />} />
                    <Route path="Add-Types" element={<AddTypes />} />
                    <Route path="All-users" element={<AdminUsersPage />} />
                    <Route path="Upload-banners" element={<BannerUpload />} />
                    <Route path="publish-A-News" element={<NewsAlertsForm />} />
                    <Route path="Products-Manager" element={<ProductsPage />} />
                    <Route path="Product-Deals" element={<ProductDeals />} />
                    <Route path="Products-Color-Code" element={<ProductColorsPage />} />
                    <Route path="Main-sub-category" element={<AdminSubMainCategories />} />
                    <Route path="Add-business-tools" element={<AdminBusinessTools />} />
                    <Route path="Template-Type-Manager" element={<TemplateTypeManager />} />
                    <Route path="Add-Templates" element={<TemplateCRUD />} />
                    <Route path="Add-Size" element={<AddSize />} />tes
                    <Route path="Add-Template-Data" element={<StaticDesignForm />} />
                </Route>
            </Routes>
        </Router>
        
    );
}

export default App;
